'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import format from '../../helpers/format'
// import convert from '../../helpers/convert'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _RecentBlogPosts = require('./RecentBlogPosts.css');

var _RecentBlogPosts2 = _interopRequireDefault(_RecentBlogPosts);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecentBlogPosts = (_dec = (0, _reactCssModules2.default)(_RecentBlogPosts2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RecentBlogPosts, _Component);

  function RecentBlogPosts(props) {
    (0, _classCallCheck3.default)(this, RecentBlogPosts);
    return (0, _possibleConstructorReturn3.default)(this, (RecentBlogPosts.__proto__ || (0, _getPrototypeOf2.default)(RecentBlogPosts)).call(this, props));
  }

  (0, _createClass3.default)(RecentBlogPosts, [{
    key: 'render',
    value: function render() {
      var posts = _config2.default.blog;
      return _react2.default.createElement(
        'div',
        { styleName: 'blog-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'blog-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'blog-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'blog-title' },
              'Recent blog posts'
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              /* for each post, a column */
              posts.map(function (item, i) {
                return _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 12, md: 4, key: i },
                  _react2.default.createElement(
                    _.Link,
                    {
                      to: _config2.default.links.blog + item.url,
                      title: item.title
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'card' },
                      _react2.default.createElement('div', {
                        styleName: 'card-img',
                        style: {
                          backgroundImage: 'url(' + item.image + ')'
                        }
                      }),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'card-title' },
                        item.title
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'card-date' },
                        (0, _moment2.default)(item.date).format('MMM D, YYYY')
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'card-subtitle' },
                        item.subtitle
                      )
                    )
                  )
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'blog-more' },
              _react2.default.createElement(
                _.Link,
                {
                  to: _config2.default.links.blog,
                  title: 'Fossil Free Funds Blog',
                  roundbutton: true
                },
                'More blog posts',
                _react2.default.createElement(_.LinkIcon, null)
              )
            )
          )
        )
      );
    }
  }]);
  return RecentBlogPosts;
}(_react.Component)) || _class);
exports.default = RecentBlogPosts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RecentBlogPosts/RecentBlogPosts.js
// module id = 1385
// module chunks = 0